<div class="mb-3 {{ field.className }}" [class.d-none]="to.hidden">
  <label class="form-label" [for]="to['name']">
    {{ to.label }}

    @if (to.required) {
      *
    }
  </label>

  <app-quill-editor
    class="mb-0"
    [id]="to['name']"
    [labelId]="''"
    [attr.name]="to['name']"
    #textEditorElement
    [formControl]="formControl"
    [formlyAttributes]="field"
  ></app-quill-editor>
</div>
